export const htmlTemplateDraftKey = (scope: string, contentId: string): string => `${scope}:draft:${contentId}`;

export const readHtmlTemplateDraft = <T>(key: string): T | null => {
    try {
        const raw = localStorage.getItem(key);
        return raw ? (JSON.parse(raw) as T) : null;
    } catch {
        return null;
    }
};

export const writeHtmlTemplateDraft = (key: string, value: unknown): void => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch {
        // Ignore local storage failures. Saving to the backend is the source of truth.
    }
};

export const clearHtmlTemplateDraft = (key: string): void => {
    try {
        localStorage.removeItem(key);
    } catch {
        // Ignore local storage failures. Saving to the backend is the source of truth.
    }
};
